import type { SVGProps } from 'react';

const SvgOmnichannelBuilder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="omnichannel-builder"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill={props.color}
      d="M21.03 21.24h7.68c1.52 0 2.75-1.23 2.75-2.75v-2.64c0-1.52-1.23-2.75-2.75-2.75h-7.68c-1.52 0-2.75 1.23-2.75 2.75v.57H9.14c-.69 0-1.25-.56-1.25-1.25V8.66h3.09c1.52 0 2.75-1.23 2.75-2.75V3.27c0-1.52-1.23-2.75-2.75-2.75H3.29C1.78.52.54 1.76.54 3.27v2.64c0 1.52 1.23 2.75 2.75 2.75h3.09v16.75c0 1.52 1.23 2.75 2.75 2.75h9.14v.57c0 1.52 1.23 2.75 2.75 2.75h7.68c1.52 0 2.75-1.23 2.75-2.75v-2.64c0-1.52-1.23-2.75-2.75-2.75h-7.68c-1.52 0-2.75 1.23-2.75 2.75v.57H9.13c-.69 0-1.25-.56-1.25-1.25v-7.8c.38.19.8.31 1.25.31h9.14v.57c0 1.52 1.23 2.75 2.75 2.75ZM2.04 5.91V3.27c0-.69.56-1.25 1.25-1.25h7.68c.69 0 1.25.56 1.25 1.25v2.64c0 .69-.56 1.25-1.25 1.25H3.29c-.69 0-1.25-.56-1.25-1.25m17.74 20.18c0-.69.56-1.25 1.25-1.25h7.68c.69 0 1.25.56 1.25 1.25v2.64c0 .69-.56 1.25-1.25 1.25h-7.68c-.69 0-1.25-.56-1.25-1.25zm0-10.23c0-.69.56-1.25 1.25-1.25h7.68c.69 0 1.25.56 1.25 1.25v2.64c0 .69-.56 1.25-1.25 1.25h-7.68c-.69 0-1.25-.56-1.25-1.25z"
    />
  </svg>
);

export default SvgOmnichannelBuilder;
